/* MURPH · Refonte DA : prix de l'offre sélectionnée dans le bouton « Ajouter au panier ».
   Recopie le prix déjà calculé par la barre panier collante (snippet murph-sticky-atc :
   offre Moon Bundle active, sinon prix de la variante). Affichage uniquement. */
(function () {
  var forms = 'form[id^="product-form-main-"] .product-form__add-button';
  if (!document.querySelector(forms)) return;

  function source() { return document.querySelector('.murph-satc [data-satc-price]'); }

  function apply() {
    var src = source();
    document.querySelectorAll(forms).forEach(function (btn) {
      var host = btn.querySelector('.loader-button__text') || btn;
      var span = btn.querySelector('.murph-atc-price');
      var price = src && !src.hidden ? src.textContent.trim() : '';
      var ok = price && /ajouter au panier/i.test(host.textContent);
      if (!ok) { if (span) span.remove(); return; }
      var txt = '\u00a0·\u00a0' + price;
      if (!span) { span = document.createElement('span'); span.className = 'murph-atc-price'; host.appendChild(span); }
      if (span.textContent !== txt) span.textContent = txt;
    });
  }

  var obs = new MutationObserver(function () { window.requestAnimationFrame(apply); });
  function watch() {
    var src = source();
    if (src) obs.observe(src, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    document.querySelectorAll(forms).forEach(function (btn) { obs.observe(btn, { childList: true, subtree: true }); });
  }

  function start() { apply(); watch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  setTimeout(apply, 1600); setTimeout(apply, 4200);
})();

/* MURPH · Icônes Lucide (licence ISC) pour les puces sous le prix (.mspecs).
   Reconnaît la puce par son texte, remplace seulement le dessin du SVG. */
(function () {
  var I = {"plane": "<path d=\"M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z\"/>", "backpack": "<path d=\"M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z\"/> <path d=\"M8 10h8\"/> <path d=\"M8 18h8\"/> <path d=\"M8 22v-6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6\"/> <path d=\"M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2\"/>", "shield-check": "<path d=\"M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z\"/> <path d=\"m9 12 2 2 4-4\"/>", "book-open": "<path d=\"M12 7v14\"/> <path d=\"M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z\"/>", "sticker": "<path d=\"M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z\"/> <path d=\"M14 3v4a2 2 0 0 0 2 2h4\"/> <path d=\"M8 13h.01\"/> <path d=\"M16 13h.01\"/> <path d=\"M10 16s.8 1 2 1c1.3 0 2-1 2-1\"/>", "gift": "<rect x=\"3\" y=\"8\" width=\"18\" height=\"4\" rx=\"1\"/> <path d=\"M12 8v13\"/> <path d=\"M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7\"/> <path d=\"M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5\"/>"};
  var R = [[/cabine/i, 'plane'], [/\d+\s?L\b/i, 'backpack'], [/oxford/i, 'shield-check'], [/ouverture/i, 'book-open'], [/patchs? velcro/i, 'sticker'], [/patch murph/i, 'gift']];
  function run() {
    document.querySelectorAll('.mspecs').forEach(function (box) {
      if (box.classList.contains('is-lucide')) return;
      box.querySelectorAll(':scope > *').forEach(function (chip) {
        var svg = chip.querySelector('svg'); if (!svg) return;
        var t = chip.textContent || '', k = null;
        for (var i = 0; i < R.length; i++) { if (R[i][0].test(t)) { k = R[i][1]; break; } }
        if (!k) return;
        svg.innerHTML = I[k];
        svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('stroke-width', '1.5');
        svg.setAttribute('stroke', chip.classList.contains('g') ? '#339999' : '#2b2b2b');
      });
      box.classList.add('is-lucide');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
